import { call, put, select, takeEvery } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import storesAPI from '../../api/stores';
import { Creators as StoresCreators, Types } from '../../reducers/stores';
import { getCartId, getCustomerCep, setCustomerCep } from '../../utils/cookies';
import getState from '../../utils/getState';

function* storesRequest({ cep, isChangeQuantity, sellerId }) {
  try {
    const {
      app: { asPath, config = {} },
      product: { currentSku },
      cart: { id },
      customer,
      stores,
    } = yield select(getState);

    const cartId = id || customer.cartId || getCartId();
    const isRouteStore = asPath.includes('lojas');
    const { siteId, domain } = config;
    const sku = currentSku.getIn(['id']);

    const validCep = cep || getCustomerCep(domain);
    let query = {};

    if (validCep && validCep.length < 8) throw 'Cep inválido';

    if (validCep) {
      query.cep = validCep;
    }

    if (sku) {
      query.sku = sku;
    }

    if (!sku && cartId) {
      query.cartId = cartId;
    }

    if (
      validCep === stores.getIn(['cep', sellerId]) &&
      sku === stores.productId &&
      stores.getIn(['stores'], []).length > 1 &&
      !isChangeQuantity
    ) {
      yield put(StoresCreators.storesSuccess(stores.stores, sku, validCep));
      return;
    }

    if (isRouteStore) {
      query = {};
    }

    let data;

    if (isRouteStore || sellerId) {
      data = yield call(storesAPI.get, sellerId, query, siteId);
    } else {
      data = yield call(storesAPI.getNearest, siteId, query);
    }

    data = data.filter((store, index, self) => {
      return index === self.findIndex((s) => s.id === store.id);
    });

    setCustomerCep(validCep, domain);

    if (!data.length) {
      throw 'Nenhuma loja encontrada';
    }

    yield put(StoresCreators.storesSuccess(data, sku, validCep, isRouteStore, sellerId));
  } catch (error) {
    yield put(StoresCreators.storesFailed({ ...formatError(error), cart: true }));
  }
}

export default function* watch() {
  yield takeEvery(Types.STORES_REQUEST, storesRequest);
}
